'use client'

import { createConfirmationCreater, createReactTreeMounter, createMountPoint } from 'react-confirm'

const mounter = createReactTreeMounter()

// eslint-disable-next-line
export const createConfirmation = createConfirmationCreater(mounter)
export const ConfirmMountPoint = createMountPoint(mounter)
